import commons from 'frontend/commons/commons';
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const NavBarItem = ({ item, url }) => (
  <a href={url}>
    <div className="flex items-center mr-2 py-3 px-4 mb-2 text-2xl font-thin">
      <i className={`text-gray-800 text-right ${item.icono.codigo} mr-3`} />
      <span className="text-gray-800 text-sm font-medium">{item.descripcion}</span>
    </div>
  </a>
);

function rendernavBarComponents(navBarItems) {
  return (
    navBarItems &&
    navBarItems.map((item) => {
      const url = commons.urlForNavBarItem(item);
      return (
        <NavBarItem
          key={item.id}
          {...{
            item,
            url,
          }}
        />
      );
    })
  );
}

export default function NavBarMobile() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('layout');
  
  const templateData = useSelector((state) => state.applicationState.templateData);
  
  const navBarItems = useMemo(() => 
    templateData.mainMenu.filter((item) => item.activo === true),
    [templateData.mainMenu]
  );
  
  const email = useMemo(() => templateData.header.email_contacto, [templateData.header.email_contacto]);
  const phoneNumber = useMemo(() => templateData.header.telefono_contacto, [templateData.header.telefono_contacto]);
  
  const showButtonPanel = useMemo(() => 
    (email && email !== '') || (phoneNumber && phoneNumber !== ''),
    [email, phoneNumber]
  );

  return (
    <div className="block">
      <button type="button" onClick={() => setShow((prev) => !prev)} className="menu-button">
        <span className="text-white mr-2">{t('common.menu')}</span>
        <i className="text-2xl text-white fas fa-bars" />
      </button>
      <div
        className={`
        ${show ? 'block' : 'hidden'}
        fixed top-0 right-0 w-full h-full bg-gray-200 z-50 opacity-90
        md:w-72 md:h-auto md:overflow-y-auto md:h-full
        animate-side
      `}
      >
        <div className="container pt-3">
          <div className="flex justify-end text-gray-600">
            <button
              type="button"
              onClick={() => setShow((prev) => !prev)}
              className="text-3xl px-3 py-2"
            >
              <i className="fas fa-times" />
            </button>
          </div>
          <div className="flex flex-col">{rendernavBarComponents(navBarItems)}</div>
        </div>
        {showButtonPanel && (
          <div className="fixed bottom-0 left-0 w-full max-h-8 bg-gray-800 text-white xl:w-72">
            {email && email !== '' && (
              <div className="flex items-center">
                <div className="container py-1">
                  {email}
                  <i className="ml-2 far fa-envelope" />
                </div>
              </div>
            )}
            {phoneNumber && phoneNumber !== '' && (
              <div className="flex items-center">
                <div className="container py-1">
                  {phoneNumber}
                  <i className="ml-2 fas fa-phone" />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
